import { vservice } from '@niknevis/vue-modules'
import { EditorService } from '@/modules/common/editor/services/editor.service'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { EditorUploadImageRequestsModel } from '@/modules/common/editor/models/editor-requests.model'
import EditorStore from '@/modules/common/editor/stores/editor.store'

@vservice()
export class EditorUploadFileUseCase {
  constructor(
    private readonly store: EditorStore,
    private readonly service: EditorService
  ) {
  }

  private readonly remoteData = RemoteData.notAsked<EditorUploadImageRequestsModel>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get getFile() {
    return this.remoteData.fold(
      () => null,
      () => null,
      value => value,
      () => null
    )
  }

  execute(editorBlob, successFn, failureFn) {
    this.store.setImageUploadLoading(true)
    return this.remoteData.fromPromise(
      this.service.imageUpload(editorBlob.blob())
    )
      .then(() => {
        successFn(this.getFile)
        this.store.setImageUploadLoading(false)
      })
      .catch(failureFn)
      .finally(() => {
        this.store.setImageUploadLoading(false)
      })
  }
}
